import {useMutation} from "@tanstack/react-query";

import {editServiceNoteMutationOptions} from "./edit-service-note.mutation-options";

export function useEditServiceNote(id: string, noteId: number) {
  return useMutation(editServiceNoteMutationOptions(id, noteId));
}
